$(function() {
	// @codekit-prepend '../js/registration/functions.js'
	// @codekit-prepend '../js/registration/pusher.js'
	// @codekit-prepend '../js/registration/notifications.js'
	// @codekit-prepend '../js/registration/file-uploader.js'
	// @codekit-prepend '../js/registration/files-uploader.js'
	// @codekit-prepend '../js/registration/profile-uploader.js'
	// @codekit-prepend '../js/registration/avatar-uploader.js'
	// @codekit-prepend '../js/registration/dropdown.js'
	// @codekit-prepend '../js/registration/accounts.js'
	// @codekit-prepend '../js/registration/profile.js'
	// @codekit-prepend '../js/registration/settings.js'
	// @codekit-prepend '../js/registration/scholarships.js'
	// @codekit-prepend '../js/registration/application.js'
	// @codekit-prepend '../js/registration/staff-application.js'
	// @codekit-prepend '../js/registration/accept-scholarship.js'
	
	// @codekit-prepend '../js/registration/children.js'
	// @codekit-prepend '../js/registration/cards.js'
	// @codekit-prepend '../js/registration/new-application-payment.js'
	// @codekit-prepend '../js/registration/invoice.js'
});


